module.exports = __webpack_public_path__ + "static/media/arrow-return-right.c95b5caf.svg";